<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;">
<!--        <div class="img-title">
            <img src="@/assets/tip.png" alt='版权登记'/>
            <span>由版权家为你自行上传的作品进行的版权存证，版权家不对您上传内容的真实性作验证。</span>
        </div>-->

        <div class="table-list" style="height:auto;min-height: 726px">
            <div class="table-list-title">
                <span style="margin-left:25px">我的存证</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker @on-change="changeDate" :value="value2" format="yyyy-MM-dd" type="daterange"
                                 placement="bottom-end" placeholder="选择日期" style="width: 200px"></Date-picker>
                    <span class="choose-group-span">请选择文件类型</span>
                    <i-select v-model="model1" placeholder="全部" style="width:126px" @on-change="selectType">
                        <i-option v-for="(item,index) in cityList" :key="index" :value="index">{{ item }}</i-option>
                    </i-select>
                    <div class="father-box-input">
                        <input placeholder="请输入作品名称" v-model="name" class="select-input-self"
                               @keyup.enter="addworkname"></input>
                        <img @click="addworkname" src="@/assets/search.png" class="search-icon" alt='版权登记'/>
                    </div>
                    <button @click="addworkname" class="btn-84">查询</button>
                    <button class="btn-84" style="margin:0px 30px 0px 20px" @click="newOpen">新增存证</button>
                </div>
            </div>
            <div class="caozuo-box">
<!--                <button class="xuqi_btn" @click="insuranceCert">上保险</button>-->
<!--                <img src="../../insurance/images/wenhao.png" style="width:16px;height:16px;cursor: pointer;" @click="goInsurance" alt='版权登记'/>-->
<!--                <button class="btn-108" @click="applyNotarization">电子数据确认函</button>-->
                <!-- <button v-if="item.electronicNotarialStatus == '1' " @click="applyNotarization(item.orderSeqNo)"
                        class="btn-84" style="margin-right:20px">电子数据确认函
                </button> -->
            </div>
            <Row class="table-style-size">
<!--                <i-col span="2">选择</i-col>-->
                <i-col span="4">作品名称</i-col>
                <i-col span="2">文件数量</i-col>
                <i-col span="4">存证时间</i-col>
<!--                <i-col span="2">版权保险</i-col>-->
                <i-col span="3">证书</i-col>
                <i-col span="7">操作</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">
<!--                     <i-col span="2">
                         &lt;!&ndash; <img :src="dis" style=" width: 16px;height: 16px;cursor: no-drop;" v-if="item.insurance.insuranceStatus ==1"/> &ndash;&gt;
                        <img :src="currentIndex==index?yes:no" style=" width: 16px;height: 16px;cursor:pointer;" @click="selectItem(index,item)" alt='版权登记'/>
                    </i-col>-->
                    <i-col span="4">
                        <!-- <Tooltip :content="item.orderTitle" placement="top">{{item.orderTitle}}</Tooltip> -->
                        <Tooltip :content="item.orderTitle" placement="top"><span
                                style="display:inline-block;width:184px;height:21px;" class="notwrap">{{item.orderTitle}}
                                <img src='../../insurance/images/baoxianlog.png' style="width:16px;height:16px;" v-if="item.insurance.insuranceStatus == 1" alt='版权登记'/>
                                </span>
                        </Tooltip>
                    </i-col>
                    <i-col span="2">{{item.attachmentsNum}}</i-col>
                    <i-col span="4">{{item.createDate}}</i-col>
<!--                    <i-col span="2">
                        <a v-if="item.insurance.insuranceStatus == 0" style="color:#F7B500" @click="shangbaoxian(item)">上保险</a>
                        <a v-if="item.insurance.insuranceStatus == 1 && (item.insurance.policyUrl ==null || item.insurance.policyUrl =='')" style="color:#F7B500" @click="lookInsuranceInvoice(item)">查看保单</a>
                        <a v-if="item.insurance.insuranceStatus == 1 && item.insurance.policyUrl !=null && item.insurance.policyUrl !=''" style="color:#F7B500" @click="lookInsurance(item.insurance.policyUrl)">查看保单</a>
                    </i-col>-->
                    <i-col span="3">
                        <Tooltip :content="item.orderAuditStatus=='cert_sign_issue' ? '存证证书': '暂无存证证书'" placement="top">
                            <img :src="item.orderAuditStatus=='cert_sign_issue'?ifDciSuccess:ifFciFail"
                                 @click="downBookFinish(item.orderAuditStatus,item.orderSeqNo)"
                                 :style="{cursor:item.orderAuditStatus=='cert_sign_issue'?'pointer':'default'}" alt='版权登记'/>
                        </Tooltip>

<!--                        <Tooltip :content="item.electronicNotarialStatus=='3' ? '公证证书': '暂无公证证书'" placement="top">
                            <img class="notarization_icon"
                                 :src=" item.electronicNotarialStatus == '3' ? ifNotarizationSuccess : ifNotarizationFail"
                                 @click="downElectronicNotarialFinish(item.electronicNotarialStatus,item.orderSeqNo)"
                                 :style="{cursor:item.electronicNotarialStatus == '3' ?'pointer':'default'}" alt='版权登记'/>
                        </Tooltip>-->

                    </i-col>
                    <i-col span="7">
                        <!-- <button v-if="item.electronicNotarialStatus == '1' " @click="applyNotarization(item.orderSeqNo)"
                                class="btn-84" style="margin-right:20px">电子数据确认函
                        </button> -->
                        <button class="btn-84" @click="goDetails(item.id)" style="margin-right:20px">详情</button>
                        <button v-if="item.orderAuditStatus=='reject_editable'" class="btn-84"
                                @click="goSubmit(item.id)">重新提交
                        </button>
                        <!-- <button v-if="item.orderAuditStatus=='cert_sign_issue'" class="btn-84" style="margin:0px 20px" @click="downBook(item.orderSeqNo)">下载证书</button>
                        <button v-if="item.orderAuditStatus=='cert_sign_issue'" class="btn-84" @click="downDataBook(item.orderSeqNo)">下载存证包</button> -->
                        <div class="showphotow" v-if="item.orderAuditStatus=='cert_sign_issue'">
                            <button class="btn-84">更多操作</button>
                            <div class="showdiasy">
                                <p @click="openVerify(item.orderSeqNo)">证书核验</p>
                                <p @click="downBook(item.orderSeqNo)">下载证书</p>
                                <p @click="downDataBook(item.orderSeqNo)">下载存证包</p>
                                <p @click="downBcBook(item.orderSeqNo)">下载BC文件</p>
                            </div>
                        </div>
                    </i-col>
                </Row>
                <div class="commont-page"
                     style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total"
                          size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>
            <div class="empty-box" v-if="records.length<=0&&flag">
                <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>
        </div>


        <!-- <generalframe myheight="450" mywidth="800" @fatherMethod="showDialog = false" v-if="showDialog"
                      maintitle="确认申请电子数据保管函" ref="mychild">
            <div style="margin-top: 30px;font-size: 15px;">电子数据保管函是由厦门市公证处出具的确认函文件</div>
            <div style="display: flex; margin-top: 30px; min-height: 200px">
                <div style="width: 150px; line-height: 42px;">支付方式：</div>
                <div>
                    <component :is="PayWayCom" @onselected="payWay = $event" type="13"></component>
                </div>
            </div>
            <input @click="applyNotarizationSubmit()" :disabled="disabled" class="submit-button" type="button"
                   value="确定"/>
        </generalframe> -->
        <generalframe myheight="450" mywidth="500" @fatherMethod="showDialog = false" v-if="showDialog"
                      maintitle="确认申请电子数据保管函" ref="mychild">
            <!-- <div style="margin-top: 30px;font-size: 15px;">电子数据保管函是由厦门市公证处出具的确认函文件</div> -->
            <div style="display: flex; margin-top: 30px; min-height: 200px">
                <component :is="PayWayCom" @onselected="payWay = $event" type="13" encType='0101' :orderNo="applyNotarizationNum" @resFn="resFn"></component>
            </div>
            <input disabled class="submit-button" type="button" style='background: #cfcfcf;cursor: no-drop;' value="确定" v-if='dzRes && ((Number(dzRes.amout)<Number(dzRes.price)) || (dzRes.packageNum == 0 && dzRes.price ==0))'/>
            <input @click="applyNotarizationSubmit()" :disabled="disabled" class="submit-button" type="button" v-else
                   value="确定"/>
            <!-- <div style="width: 230px;margin:10px auto 0;display: flex;justify-content: space-between;">
                <span>余额：{{dzRes && dzRes.amountDesc}}</span>
                <a style="cursor: pointer;" @click='goCz' v-if='dzRes && (Number(dzRes.amout)<Number(dzRes.price))'>去充值</a>
            </div> -->
        </generalframe>
    </div>

</template>

<script>
    import {getOrderDownCert, getCertFileType,getInvioceInsurance,getInsuranceUrl,getShangInsurance} from '@/api/staticPage';
    import {_downloadEnc, _generateEncByOrderCommon} from '@/api/notarization'
    import Cookies from "js-cookie";
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe.vue'
    // import payWay from '@/views/main-components/pay-way';
    import payWay from '@/views/main-components/pay-way-enc';

    export default {
        metaInfo: {
            title: '我的存证|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '我的存证,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'myCert',
        components: {
            generalframe,
            payWay
        },
        data() {
            return {
                currentIndex:null,
                yes: require('../../insurance/images/yes.png'),
                no:require("../../insurance//images/no.png"),
                dis:require("../../insurance//images/disCheck.png"),
                total: 0,
                pageSize: 8,
                pageNumber: 1,
                startDate: '',
                endDate: '',
                name: '',
                attachementsTypes: '',
                value2: [],
                cityList: [],
                model1: 'all',
                records: [],
                ifDciSuccess: require('@/assets/cert-open.png'),
                ifFciFail: require('@/assets/cert-close.png'),
                ifNotarizationSuccess: require('@/assets/notarization_active.png'),
                ifNotarizationFail: require('@/assets/notarization.png'),
                flag: false,
                pages: 0,
                flagType: 0,
                showDialog: false,
                payWay: null,
                disabled: false,
                PayWayCom: 'payWay',
                applyNotarizationNum: '',
                insuranceId:"",
                checkedData:null,
                dzRes:null
            }
        },
        methods: {
            goCz(){
                this.$router.push({
                    name: "wallet"
                });
            },
            resFn(data){
                this.dzRes = data;
            },
            //下载电子发票
            lookInsuranceInvoice(data){
                getShangInsurance(data.orderSeqNo).then(res=>{
                    if(res.code == 200){
                        window.open(res.result, '_blank')
                    }else{
                        toast(res.message)
                    }
                })
            },
             //去了解上保险险情
            goInsurance(){
                this.$router.push({
                    path:'/insurance'
                })
            },
            //选择作品上保险
            //单选
            selectItem(index,data){
                this.currentIndex=index;
                console.log(data)
                this.insuranceId=data.orderSeqNo;
                this.checkedData = data
            },
            //查看保单
            lookInsurance(url){
                window.open(url, '_blank')
            },
            //上保险
            shangbaoxian(val){
                this.$Spin.show();
                let data={
                    refSeqNo:val.orderSeqNo,
                    type:1
                }
                getInsuranceUrl(data).then(res=>{
                    if(res.code == 200){
                        this.$Spin.hide();
                        window.open(res.result)
                        toast("成功上保险")
                        // this.applyBillFlagRegister = false;
                    }else{
                        // this.applyBillFlagRegister = false;
                        this.$Spin.hide();
                        toast(res.message)
                    }
                })
            },
            insuranceCert(){
                let _this = this;
                if(_this.checkedData == null){
                    toast("请选择要上保险的订单")
                    return false
                }
                if(_this.checkedData.orderAuditStatus != "cert_sign_issue"){
                    toast("未获得存证证书，不能购买保险")
                    return false
                }
                if(_this.checkedData.insurance.insuranceStatus == 1){
                    toast("已购买保险，不能重复购买")
                    return false
                }
                let data={
                    refSeqNo:this.insuranceId,
                    type:1
                }
                getInsuranceUrl(data).then(res=>{
                    if(res.code == 200){
                        window.open(res.result)
                        toast("成功上保险")
                            this.applyBillFlagRegister = false;
                    }else{
                            this.applyBillFlagRegister = false;
                        toast(res.message)
                    }
                })
            },
            _getCertFileType() {
                let _this = this;
                getCertFileType().then(res => {
                    if (res.code == 200) {
                        _this.cityList = Object.assign({'all': '全部'}, res.result)
                        console.log('****************', _this.cityList)
                    }
                })
            },
            selectType(val) {
                console.log('这是获取的类型', val)
                this.attachementsTypes = val == 'all' ? '' : val;
                this.pageNumber = 1;
                this._getOrderDownCert();
            },
            _getOrderDownCert() {
                let _this = this;
                let userInfo = JSON.parse(Cookies.get("userInfo"));
                let params = {
                    pageNumber: _this.pageNumber,
                    pageSize: _this.pageSize,
                    sort: 'create_date',
                    order: 'desc',
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    name: _this.name,
                    attachementsTypes: _this.attachementsTypes,
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                }
                getOrderDownCert(params).then((res) => {
                    console.log('获取的最后的实名状态', res)
                    if (res.code == 200) {
                        _this.records = res.result.records
                        _this.total = Number(res.result.total)
                        _this.flag = true;
                        _this.pages = res.result.pages
                    }
                })
            },
            changeDate(starttime, endtime) {
                this.startDate = starttime ? starttime[0] : '';
                this.endDate = starttime ? starttime[1] : '';
                this.pageNumber = 1;
                this._getOrderDownCert();
            },
            changepage(index) {
                this.pageNumber = index
                this._getOrderDownCert();
            },
            addworkname() {
                this.pageNumber = 1;
                this._getOrderDownCert();
            },
            goDetails(id) {
                console.log('获取的详情的id', id)
                this.$router.push({
                    path: '/cert-info',
                    query: {
                        id: id
                    }
                })
            },
            goSubmit(id) {
                this.$router.push({
                    path: '/apply-cert',
                    query: {
                        id: id
                    }
                })
            },

            //下载电子存证方法
            downElectronicNotarialFinish(status, id) {
                if (status == '3') {
                    _downloadEnc(id).then(res => {
                        if (res.code == 200) {
                            window.open(res.result, '_blank')
                        }
                    })
                }
            },
            downBookFinish(status, id) {
                if (status == 'cert_sign_issue') {
                    this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
                        if (res.code == 200) {
                            // this.funDownload(res.result)
                            window.open(res.result, '_blank')
                        }
                    })
                }
            },
            downBook(id) {
                this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
                    if (res.code == 200) {
                        // this.funDownload(res.result)
                        window.open(res.result, '_blank')
                    }
                })
            },
            downDataBook(id) {
                console.log(this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id);
                window.open(this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id, '_self');
            },
            downBcBook(id) {
                window.open(this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?certificateOrderSeqNos=" + id, '_self');
            },
            //证书核验
            openVerify(val) {
                let routeUrl = this.$router.resolve({
                    path: "/index/creation_verification",
                    name: 'creationVerification',
                    params: {type: this.flagType, id: val}
                });
                window.open(routeUrl.href, '_blank');
            },
            newOpen() {
                window.open('/apply-cert', '_blank');
            },
            funDownload(content) {
                const links = content;
                let aDom = document.createElement("a");
                aDom.target = "_self";
                aDom.href = links;
                aDom.download = links.substr(links.lastIndexOf('/'), links.length);
                aDom.click();
                // 创建隐藏的可下载链接
                // console.log('123456789')
                // var eleLink = document.createElement('a');
                // eleLink.download = content.substring(content.lastIndexOf('/')+1)
                // eleLink.href = content;
                // eleLink.style.display = 'none';
                // // 触发点击
                // document.body.appendChild(eleLink);
                // eleLink.click();
                // // 然后移除
                // document.body.removeChild(eleLink);
                // var form = document.createElement('form');
                // form.action = 'www.baidu.com?id=1';
                // form.target = '_blank';
                // form.method = 'POST';
                // document.body.appendChild(form);
                // form.submit();
            },


            /**************************电子数据确认函-打开加油包*************************/
            applyNotarization() {
                // let _this = this
                // let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                // if (!userInfo || userInfo == '') {
                //     _this.$store.state.app.showLoginOrRegistter = true;
                //     return false;
                // }
                // _this.applyNotarizationNum = data
                // _this.showDialog = true;
                // _this.PayWayCom = 'payWay'
                let _this = this;
                if(_this.checkedData == null){
                    toast("请选择要申请电子数据确认函的订单")
                    return false
                }
                if(_this.checkedData.electronicNotarialStatus == 0){
                    toast("未获得存证证书，不能申请电子数据确认函")
                    return false
                }
                if(_this.checkedData.electronicNotarialStatus == 2 || _this.checkedData.electronicNotarialStatus == 3){
                    toast("已申请电子数据确认函，不能重复申请")
                    return false
                }
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                if (!userInfo || userInfo == '') {
                    _this.$store.state.app.showLoginOrRegistter = true;
                    return false;
                }
                _this.applyNotarizationNum = _this.checkedData.orderSeqNo
                _this.showDialog = true;
                _this.PayWayCom = 'payWay'

            },
            /**************************电子数据确认函-提交*************************/
            applyNotarizationSubmit() {
                this.disabled = true;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                const data = {orderSeqNo: this.applyNotarizationNum};
                // if (!this.payWay) {
                //     toast('无可用次数');
                //     this.disabled = false;
                //     return false;
                // } else {
                //     if (this.payWay.gift.activityGiftId) {
                //         Object.assign(data, {activityGiftId: this.payWay.gift.activityGiftId})
                //     }
                // }

                _generateEncByOrderCommon(data).then(res => {
                    if (res.code == 200) {
                        toast('申请成功')

                        let records = this.records;
                        let applyNotarizationNum = this.applyNotarizationNum;
                        for (let i = 0; i < records.length; i++) {
                            if (records[i].orderSeqNo == applyNotarizationNum) {
                                records[i].electronicNotarialStatus = '2';
                                break;
                            }
                        }
                        this.records = records;
                        this.disabled = false;
                        this.showDialog = false;
                        window.open('/myNotarization', '_blank');

                    } else if (res.code == 214) {
                        toast("请购买会员后使用功能")
                        this.$router.push({path: '/huiyuan.html'})
                    } else if (res.code == 213) {
                        toast("请实名认证后使用功能")
                        if (userInfo.accountType == "person") {
                            this.$router.push('/authentication')
                        } else {
                            this.$router.push('/authentication')
                        }
                    } else {
                        toast(res.message);
                        this.disabled = false;
                    }
                })
            }
        },
        mounted() {
            this._getCertFileType();
            this._getOrderDownCert();
        }
    }
</script>

<style scoped lang="less">
    .showphotow {
        display: inline-block;
        height: 100%;
        position: relative;

        .showdiasy {
            position: absolute;
            top: 35px;
            left: 0px;
            background: #fff;
            box-shadow: 0 2px 18px 0 rgba(179, 189, 199, .47);
            border-radius: 4px;
            z-index: 777;
            width: 110px;
            display: none;

            p {
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                font-size: 12px;
                background-color: #fff;
                color: #929292;
            }

            p:hover {
                background-color: #f7f9fb;
                color: #4e4e4e;
            }
        }

        &:hover {
            .showdiasy {
                display: block;
            }
        }
    }

    .notarization_icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 8px;
    }

    .submit-button {
        width: 230px;
        height: 42px;
        background: rgba(255, 216, 0, 1);
        border-radius: 4px;
        line-height: 42px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
        cursor: pointer;
        border: none;
        outline: none;
    }
.caozuo-box{
    margin-bottom: 12px;
    background: #fff;
    display:flex;
    flex-direction:row;
    align-items:center;
    .xuqi_btn{
        margin-right: 10px;
        width: 84px;
        height: 33px;
        background: #ffd800;
        border: 1px solid #ffd800;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        line-height: 33px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        border: none;
        outline: none;
    }
}
.btn-108{
    width: 108px;
    height: 33px;
    background: rgba(255,216,0,0.05);
    border: 1px solid #ffd800;
    border-radius: 2px;
    font-size: 12px;
    text-align: center;
    color: #f7b500;
    line-height: 33px;
    cursor: pointer;
    margin-left: 10px;
    border: none;
    outline: none;
}
</style>
